import { Box } from "@mui/material";
import styled from "@emotion/styled";
import LubewatchPng from "../../assets/images/logos/caltex-lubewatch-logo.png";

const LubewatchLogo = styled("img")({
    height: "80px;",
});

const Homepage = () => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#004a613a",
            }}
        >
            <LubewatchLogo src={LubewatchPng} alt="Caltex Lubewatch" />
        </Box>
    );
};

export default Homepage;
